module.exports = {"440303001":"桂园街道","440303002":"黄贝街道","440303003":"东门街道","440303004":"翠竹街道","440303005":"南湖街道","440303006":"笋岗街道","440303007":"东湖街道","440303008":"莲塘街道","440303009":"东晓街道","440303010":"清水河街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440303.json
// module id = 2092
// module chunks = 0